package com.schoolconnect.app.datasource.network.response

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class TeacherDashboardOverviewResponse(
    @SerialName("my_classes")
    val myClasses: List<TeacherDashboardClassResponse> = emptyList(),
    @SerialName("total_students")
    val totalStudents: Int? = null,
    @SerialName("recent_notices")
    val recentNotices: List<TeacherDashboardNoticeResponse> = emptyList(),
    @SerialName("upcoming_events")
    val upcomingEvents: List<TeacherDashboardEventResponse> = emptyList()
)

@Serializable
data class TeacherDashboardClassResponse(
    @SerialName("class_section_id")
    val classSectionId: String? = null,
    @SerialName("class_name")
    val className: String? = null,
    @SerialName("section_name")
    val sectionName: String? = null,
    @SerialName("academic_year_label")
    val academicYearLabel: String? = null,
    @SerialName("role_type")
    val roleType: String? = null,
    @SerialName("subject_name")
    val subjectName: String? = null,
    @SerialName("boys_count")
    val boysCount: Int? = null,
    @SerialName("girls_count")
    val girlsCount: Int? = null,
    @SerialName("total_students")
    val totalStudents: Int? = null
)

@Serializable
data class TeacherDashboardNoticeResponse(
    val id: String? = null,
    val title: String? = null,
    @SerialName("notice_id")
    val noticeId: String? = null,
    val audience: String? = null,
    @SerialName("created_at")
    val createdAt: String? = null
)

@Serializable
data class TeacherDashboardEventResponse(
    val id: String? = null,
    val title: String? = null,
    @SerialName("event_date")
    val eventDate: String? = null,
    @SerialName("event_id")
    val eventId: String? = null,
    val audience: String? = null
)
